/*
 * Proprietary and confidential | 2026 | SoundTalks NV
 */

import { fromJS } from 'immutable';
import * as constants from 'data/constants/companies';
import LoadingProgress from 'data/utils/reducers/loading';

export const loadingProgress = new LoadingProgress('company');

const mergeData = (state, payload) =>
  state.withMutations((newState) => {
    const {
      entities: { companies },
    } = payload || { entities: { companies: null } };

    if (companies) {
      newState.mergeIn(['entities'], fromJS(companies));
    }
  });

const initialState = fromJS({
  entities: {},
});

export default (state = initialState, action) => {
  switch (action.type) {
    case constants.LOAD_START:
      return loadingProgress.setLoading(state);
    case constants.LOAD_FAILED:
      return loadingProgress.setLoadFailed(state);
    case constants.LOAD_SUCCESS:
      return state.withMutations((newState) => {
        mergeData(newState, action.payload);
        loadingProgress.setLoaded(newState);
      });
    case constants.CLEAR:
      return initialState;
    default:
      return state;
  }
};
